module.exports = __webpack_public_path__ + "img/pear.b96829dd.svg";